export default __webpack_public_path__ + "static/media/binoculars.57277943.svg";